import Header from 'components/Common/Header/Header';
import CouponCreateBody from 'components/CouponComponents/CouponCreateComponents/CouponCreateBody/CouponCreateBody';
import React, { useEffect } from 'react';

const CouponCreate = () => {
  useEffect(() => {
    document.title = 'Coupons';
  }, []);
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="coupons" />

      {/* ---- body section ---- */}
      <CouponCreateBody />
    </main>
  );
};

export default CouponCreate;
